/* eslint-disable jsx-a11y/anchor-is-valid */
import classnames from 'classnames';
import React, { useEffect, useState } from 'react';
import { Controller } from 'react-hook-form';
import { Link, useHistory } from 'react-router-dom';
import {
  Button,
  Card,
  CardBody,
  CardText,
  CardTitle,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
} from 'reactstrap';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import { useBrand } from '@hooks/useBrand';

import logo from '@src/assets/images/logo/logo.png';
import '@styles/base/pages/page-auth.scss';

import { Loading } from '@src/@core/components/loading';

import AuthCode from 'react-auth-code-input';
import useAuthenticationForm from './useAuthenticationForm';

import './style.scss';

const TwoFactorAuthenticationForm: React.FC = () => {
  const { brand, nameTab } = useBrand();
  const [blocking, setBlocking] = useState(false);
  const [blockingResend, setBlockingResend] = useState(false);
  const [result, setResult] = useState<string>();
  const history = useHistory();

  function handleChangeBlocking(isBlocking: boolean): void {
    setBlocking(isBlocking);
  }

  function handleChangeBlockingResend(isBlocking: boolean): void {
    setBlockingResend(isBlocking);
  }

  const { register, errors, onSubmit, onClick, control } =
    useAuthenticationForm({
      onChangeBlocking: handleChangeBlocking,
      onChangeBlockingResend: handleChangeBlockingResend,
    });

  const handleLoginInAgain = () => {
    localStorage.removeItem('userData');
    history.push('/login');
  };

  useEffect(() => {
    document.title = `Login | ${nameTab}`;
  }, [nameTab]);

  return (
    <>
      <div className="auth-wrapper auth-v1 px-2">
        <div className="auth-inner py-2">
          <Card className="mb-0">
            <CardBody>
              <Link
                className="brand-logo"
                to="/"
                onClick={(e) => e.preventDefault()}
              >
                {nameTab.toLowerCase() !== 'ultragate' ? (
                  <img
                    src={brand}
                    alt={`Logo ${nameTab}`}
                    className="img-fluid"
                    style={{ width: '189px' }}
                  />
                ) : (
                  <img src={logo} alt="Logo Ultragate" className="img-fluid" />
                )}
              </Link>
              <CardTitle tag="h4" className="mb-1">
                Autenticação
              </CardTitle>
              <p className="mb-2">
                Por favor insira o código que foi enviado para o seu e-mail.
              </p>
              <Form className="auth-login-form" onSubmit={onSubmit}>
                <FormGroup>
                  <Label className="form-label ml-50" for="code">
                    Código
                  </Label>
                  <Controller
                    rules={{ required: true }}
                    control={control}
                    defaultValue=""
                    name="code"
                    render={({ onChange }) => {
                      return (
                        <AuthCode
                          containerClassName="d-flex justify-content-around"
                          inputClassName={classnames('input-code form-control')}
                          autoFocus
                          allowedCharacters="numeric"
                          onChange={onChange}
                        />
                      );
                    }}
                  />

                  {errors && errors.code && (
                    <p className="mb-0 mt-1 ml-50 invalid-feedback d-block">
                      {errors.code.message}
                    </p>
                  )}
                </FormGroup>
                <Button type="submit" color="primary" block>
                  Válidar
                </Button>

                <div className="my-2 text-center">
                  <p>
                    Não recebeu o codigo?{' '}
                    <a
                      onClick={onClick}
                      className="text-primary font-weight-bold"
                    >
                      Reenviar
                    </a>
                  </p>
                  <p className="text-center mt-2">
                    <Link to="/send-code-whatsapp">
                      <span className="align-middle">
                        Enviar via telefone cadastrado
                      </span>
                    </Link>
                  </p>
                  <p>
                    <a
                      className="text-primary font-weight-bold"
                      onClick={handleLoginInAgain}
                    >
                      <ins>Fazer login novamente</ins>
                    </a>
                  </p>
                </div>
              </Form>
            </CardBody>
          </Card>
        </div>
      </div>

      <Loading blocking={blocking} />
      <Loading blocking={blockingResend} />
    </>
  );
};

const RECAPTCHA_SITE_KEY = process.env.REACT_APP_API_RECAPTCHA_SITE_KEY!;

export const TwoFactorAuthentication: React.FC = () => (
  <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_SITE_KEY}>
    <TwoFactorAuthenticationForm />
  </GoogleReCaptchaProvider>
);
